import { create } from "zustand";

/** Payload carried by the `ptEventManagerProps` postMessage (Parent → Child). */
export type EventManagerMessagePayload = {
  moduleId?: string | number;
  userId?: string;
  primaryBusinessObjectTypeId?: string;
  primaryBusinessObjectId?: string;
};

type EventManagerMessageStore = {
  eventManagerMessageData?: EventManagerMessagePayload;
  setEventManagerMessage: (data: EventManagerMessagePayload) => void;
};

export const useEventManagerMessageStore = create<EventManagerMessageStore>(
  (set) => ({
    eventManagerMessageData: undefined,
    setEventManagerMessage(data) {
      set(() => ({
        eventManagerMessageData: data,
      }));
    },
  })
);
